import moment from 'moment'

const shortDateFormat = 'DD/MM/YYYY'

/*let longDateFormat: string = "DD/MM/YYYY HH:mm:ss";
let mediumDateFormat: string = "DD/MM/YYYY HH:mm";
let shortDateFormatISO: string = "YYYY/MM/DD";
let shortDateFormatISOHyphen: string = "YYYY-MM-DD";*/

export const dateFormatter = {
    toShortDate: (date: Date | string | null): string => {
        if (!date) return ''

        return moment(date).format(shortDateFormat)
    },

    stringToDate: (dayString: string | Date | undefined | null) : Date | undefined => {
        if (!dayString) return undefined;

        return new Date(dayString);
    }

    /*toISOShortDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(shortDateFormatISO);
    },

    toISOHyphenShortDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(shortDateFormatISOHyphen);
    },

    toLongDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(longDateFormat);
    },

    toMediumDate: (date: Date | string | null): string => {
        if (!date)
            return "";

        return (moment(date)).format(mediumDateFormat);
    },

    isOlderAsOfToday: (date: Date | string | null) : boolean => {
        if (!date)
            return false;

        return date > (new Date());
    },

    convertDaysToMonths: (days: number | undefined | null) : number => {
        if (!days) return 0;

        return Math.ceil(days / 30);
    },

    stringToDate: (dayString: string | Date | undefined | null) : Date | undefined => {
        if (!dayString) return undefined;

        return new Date(dayString);
    }*/
}
